import { render, staticRenderFns } from "./PortraitMore.vue?vue&type=template&id=4528c639&scoped=true"
import script from "./PortraitMore.vue?vue&type=script&lang=js"
export * from "./PortraitMore.vue?vue&type=script&lang=js"
import style0 from "./PortraitMore.vue?vue&type=style&index=0&id=4528c639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4528c639",
  null
  
)

export default component.exports